module.exports = __webpack_public_path__ + "static/media/icFiber.0bdbdfc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Ecosystem/images/icFiber.svg
// module id = 1007
// module chunks = 0